var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.25H9C3.57 23.25 1.25 20.93 1.25 15.5V9.5C1.25 4.07 3.57 1.75 9 1.75H15C20.43 1.75 22.75 4.07 22.75 9.5V15.5C22.75 20.93 20.43 23.25 15 23.25ZM9 3.25C4.39 3.25 2.75 4.89 2.75 9.5V15.5C2.75 20.11 4.39 21.75 9 21.75H15C19.61 21.75 21.25 20.11 21.25 15.5V9.5C21.25 4.89 19.61 3.25 15 3.25H9Z",
    fill: "#669D24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.48 8.36H2.52002C2.11002 8.36 1.77002 8.02 1.77002 7.61C1.77002 7.2 2.10002 6.86 2.52002 6.86H21.48C21.89 6.86 22.23 7.2 22.23 7.61C22.23 8.02 21.9 8.36 21.48 8.36Z",
    fill: "#669D24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52002 8.22C8.11002 8.22 7.77002 7.88 7.77002 7.47V2.61C7.77002 2.2 8.11002 1.86 8.52002 1.86C8.93002 1.86 9.27002 2.2 9.27002 2.61V7.47C9.27002 7.88 8.93002 8.22 8.52002 8.22Z",
    fill: "#669D24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.48 7.77C15.07 7.77 14.73 7.43 14.73 7.02V2.61C14.73 2.2 15.07 1.86 15.48 1.86C15.89 1.86 16.23 2.2 16.23 2.61V7.02C16.23 7.44 15.9 7.77 15.48 7.77Z",
    fill: "#669D24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 18.62C10.73 18.62 10.39 18.53 10.08 18.36C9.4 17.96 9 17.16 9 16.15V13.75C9 12.74 9.4 11.93 10.09 11.53C10.78 11.13 11.68 11.19 12.55 11.7L14.63 12.9C15.5 13.4 16.01 14.15 16.01 14.95C16.01 15.75 15.5 16.5 14.62 17L12.54 18.2C12.06 18.48 11.56 18.62 11.09 18.62ZM11.1 12.77C11 12.77 10.91 12.79 10.84 12.83C10.63 12.95 10.5 13.29 10.5 13.75V16.15C10.5 16.6 10.63 16.94 10.84 17.07C11.05 17.19 11.41 17.13 11.8 16.9L13.88 15.7C14.27 15.47 14.51 15.19 14.51 14.95C14.51 14.71 14.28 14.43 13.88 14.2L11.8 13C11.54 12.85 11.29 12.77 11.1 12.77Z",
    fill: "#669D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.fb1332b0daa34c7ffa686813dc8bea4d.svg";
export { ForwardRef as ReactComponent };